/**
 * Format a file size in bytes to a human-readable string.
 *
 * @param {number|null|undefined} bytes - File size in bytes
 * @returns {string} Formatted file size (e.g., "1.5 KB", "2.0 MB")
 */
export function formatFileSize(bytes) {
  if (bytes == null || bytes < 0) return "--"
  if (bytes === 0) return "0 B"

  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`
  if (bytes < 1073741824) return `${(bytes / 1048576).toFixed(1)} MB`
  return `${(bytes / 1073741824).toFixed(1)} GB`
}
